function Steps({ steps }) {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">

      <ul className="space-y-12 relative">
        {steps.map((step, idx) => (
          <li key={idx} className="flex items-start relative">
            
            {/* Circle + line container */}
            <div className="flex flex-col items-center mr-6 relative">
              {/* Render line only for steps except the last */}
              {idx !== steps.length - 1 && (
                <div className="absolute top-10 left-1/2 transform -translate-x-1/2 h-28 border-l-2 border-brand z-0"></div>
              )}

              {/* Outlined Circle */}
              <div className="w-10 h-10 rounded-full border-2 border-brand text-brand flex items-center justify-center font-semibold z-10 bg-white">
                {idx + 1}
              </div>
            </div>

            {/* Step content */}
            <div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-700">{step.description}</p>
            </div>

          </li>
        ))}
      </ul>
    </div>
  );
}

export default Steps;